import { gql } from "@apollo/client";

export const ISSUE_SEASON_AWARDS_MUTATION = gql`
    mutation IssueSeasonAwards(
        $topCheckins: [PlayerAwardInput]!
        $topRaids: [PlayerAwardInput]!
        $topWatchTime: [PlayerAwardInput]!
        $dryRun: Boolean
    ) {
        issueSeasonAwards(
            topCheckins: $topCheckins
            topRaids: $topRaids
            topWatchTime: $topWatchTime
            dryRun: $dryRun
        ) {
            success
            message
            awardsIssued
        }
    }
`;

export const END_SEASON_MUTATION = gql`
    mutation EndSeason {
        endSeason {
            success
            message
        }
    }
`;

export const FINALIZE_SEASON_TAGS_MUTATION = gql`
    mutation FinalizeSeasonTags {
        finalizeSeasonTags {
            success
            message
        }
    }
`;

export const START_NEW_SEASON_MUTATION = gql`
    mutation StartNewSeason($name: String!) {
        startNewSeason(name: $name) {
            success
            message
            seasonId
        }
    }
`;
